import { useUser } from '@/hooks';
import styles from './UserAvatar.module.scss';
import React, { useState } from 'react';
import { EUserAvatarSize } from '@/models';
import clsx from 'clsx';

interface UserAvatarProps {
  size: EUserAvatarSize;
}

export const UserAvatar: React.FC<UserAvatarProps> = (
  props: UserAvatarProps
) => {
  const { user } = useUser();
  const [imageError, setImageError] = useState(false);

  const shouldShowImage = user.photoURL && !imageError;

  const getAvatarPlaceholder = () => {
    if (shouldShowImage) return '';
    const str = user.displayName ? user.displayName[0] : user.email?.[0];
    return str?.toUpperCase() || '?';
  };

  const getClasses = () => {
    const arr = [styles.userAvatar];
    switch (props.size) {
      case EUserAvatarSize.small:
        arr.push(styles.small);
        break;
      case EUserAvatarSize.medium:
        arr.push(styles.medium);
        break;
      case EUserAvatarSize.large:
        arr.push(styles.large);
        break;
      case EUserAvatarSize.extraSmall:
        arr.push(styles.extraSmall);
    }
    if (!shouldShowImage) {
      arr.push(styles.placeholder);
    }
    return clsx(arr);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const getAriaLabel = () => {
    return user.displayName || user.email || 'User avatar';
  };

  return (
    <div className={getClasses()} aria-label={getAriaLabel()}>
      {shouldShowImage ? (
        <img
          src={user.photoURL}
          alt={getAriaLabel()}
          className={styles.avatarImage}
          onError={handleImageError}
        />
      ) : (
        getAvatarPlaceholder()
      )}
    </div>
  );
};
